import { Link } from "react-router-dom";
import type { ContentItem } from "@/types/content";

interface ContentCardProps {
  item: ContentItem;
  layout?: "poster" | "wide";
}

export default function ContentCard({ item, layout = "poster" }: ContentCardProps) {
  if (layout === "wide") {
    return (
      <Link
        to={`/detail/${item.id}`}
        className="group flex flex-col sm:flex-row gap-4 rounded-lg bg-background-50 border border-background-200 p-3 md:p-4 hover:border-primary-300 transition-colors cursor-pointer"
      >
        <div className="w-full sm:w-40 md:w-52 shrink-0 aspect-[16/10] rounded-md overflow-hidden bg-background-200">
          <img
            src={item.image}
            alt={item.title}
            title={`${item.title} 影视工厂`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        <div className="flex-1 min-w-0 flex flex-col">
          <span className="w-fit px-2 py-0.5 rounded text-xs bg-accent-100 text-accent-900">
            {item.genres[0]}
          </span>
          <h3 className="mt-2 text-base md:text-lg font-medium text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {item.title}
          </h3>
          <p className="mt-2 text-sm text-foreground-600 line-clamp-2 hidden sm:block">
            {item.summary}
          </p>
          <div className="mt-auto pt-3 text-xs text-foreground-500 flex items-center gap-4">
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line" />
              {item.releaseDate}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-price-tag-3-line" />
              {item.region}
            </span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={item.image}
          alt={item.title}
          title={`${item.title} 影视工厂`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        {typeof item.rating === "number" && (
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-accent-500 text-foreground-950 text-xs font-bold">
            {item.rating.toFixed(1)}
          </span>
        )}
        {item.type === "tv" && item.status && (
          <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-primary-950/80 text-background-50 text-xs">
            {item.status}
          </span>
        )}
      </div>
      <div className="p-3 flex flex-col flex-1">
        <h3 className="text-sm md:text-base font-medium text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {item.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-600 truncate">{item.cast}</p>
        <div className="mt-auto pt-2.5 flex items-center justify-between text-xs">
          <span className="text-foreground-500">{item.releaseDate}</span>
          <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-900">
            {item.genres[0]}
          </span>
        </div>
      </div>
    </Link>
  );
}